// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 995) return "shell/modern_shell.css?cacheBreaker=51a25bd37617cd5f2444";
	if (chunkId === 179) return "modules/modern_prismjs-179.css?cacheBreaker=b12127ee06be5a35313b";
	if (chunkId === 246) return "modules/modern_246-246.css?cacheBreaker=8e77bd8308a818beb0d1";
	if (chunkId === 632) return "modules/modern_externalAuth-632.css?cacheBreaker=4972dfa7f5dc949ca4a0";
	if (chunkId === 76) return "designer/modern_designer.css?cacheBreaker=af8e19fec6a1e2af00f0";
	if (chunkId === 741) return "modules/modern_741-741.css?cacheBreaker=22c9091364bf53b5474f";
	if (chunkId === 212) return "modules/modern_212-212.css?cacheBreaker=a99485964f9411c9568a";
	if (chunkId === 433) return "modules/modern_433-433.css?cacheBreaker=4a8101a0813df1ba77eb";
	if (chunkId === 517) return "modules/modern_calendar-517.css?cacheBreaker=2e6cab46db87f70102ce";
	if (chunkId === 417) return "modules/modern_417-417.css?cacheBreaker=855f7525e729b32c9aea";
	// return url for filenames based on template
	return undefined;
};